import {
    CompareFeatureBlock,
    CompareFeaturesBody,
    CompareTileBlock,
    CompareTileBody,
    ConditionalShopTileBlock,
    ConditionalShopTileBody,
    TsicommonCmsShopCompareTileset,
} from "@reactivated";

import { InternalProduct } from "../../models/catalogue";

export type ShopCompareTilesetType = TsicommonCmsShopCompareTileset;
export type ConditionalShopTileType = ConditionalShopTileBody;
export type CompareTileBodyType = CompareTileBody;
export type CompareFeaturesType = CompareTileBlock["features"];
export type FeatureType = CompareFeatureBlock["feature"];
export type TilesetFeaturesType = CompareFeaturesBody;

export const ATTRIBUTE_CLASSES = {
    soft: "Soft",
    medium: "Medium",
    hybrid: "Medium Hybrid",
    firm: "Firm",
} as const;

export type FeelAttributesType =
    (typeof ATTRIBUTE_CLASSES)[keyof typeof ATTRIBUTE_CLASSES];

export type CompareTileType = CompareTileBlock & {
    compare_tile: CompareTileBlock["compare_tile"] & {
        price: InternalProduct["price"];
        num_reviews: InternalProduct["num_reviews"];
        link: InternalProduct["link"];
        rating: InternalProduct["rating"];
        feel_options: FeelAttributesType[];
        size_options: string[];
    };
};

export type ShopTileType = ConditionalShopTileBlock & {
    shop_tile: ConditionalShopTileBlock["shop_tile"] & {
        price: InternalProduct["price"];
        num_reviews: InternalProduct["num_reviews"];
        link: InternalProduct["link"];
        rating: InternalProduct["rating"];
        feel_options: FeelAttributesType[];
        size_options: string[];
    };
};
